import { AfterViewInit, Component, viewChild, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NequiToastComponent, ToastService } from '@nequi/design-system-lib/ui/toast';

@Component({
  standalone: true,
  imports: [RouterModule, NequiToastComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements AfterViewInit {
  private readonly nequiToastComponent = viewChild.required(NequiToastComponent);

  private readonly toastService = inject(ToastService);

  public ngAfterViewInit(): void {
    this.toastService.setComponentRef(this.nequiToastComponent());
  }
}
